import { render } from "./VehicleBaseLayout.vue?vue&type=template&id=11db38e6"
import script from "./VehicleBaseLayout.vue?vue&type=script&lang=js"
export * from "./VehicleBaseLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__